//@flow
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './PositionIndicatorOverlay.scss';

type PositionIndicatorOverlayProps = {
    photoCount: number,
    currentPhotoIndex: number,
};

export const PositionIndicatorOverlay = (props: PositionIndicatorOverlayProps) => {
    // hide on loading...
    if (props.photoCount === 0) {
        return null;
    }
    return (
        <div className={styles.positionIndicatorWrapper}>
            <span className={styles.positionIndicator}>
                <FormattedMessage
                    id="interiorPhoto.photo.overlay.position"
                    defaultMessage="{current} of {count}"
                    values={{
                        current: props.currentPhotoIndex + 1,
                        count: props.photoCount,
                    }}
                />
            </span>
        </div>
    );
};

export default PositionIndicatorOverlay;
